export default {
  BASE : 0,
  SM: 576,
  MD: 768,
  LG: 960,
  XL: 1200
}